import { DefaultState, TableDataResponse } from 'features/types';
import { Paging, SelectItem } from 'api/types';
import { ResourceBaseTableView } from 'components/ResourceBaseTableComponent/types';
import { ResourceSharedStatuses } from 'features/discover-resources-by-organization';
import { FormikProps, FormikErrors } from 'formik';

export type ResourceState = DefaultState & {
  requestData: GetResourcesTable;
  data: {
    tableData: TableDataResponse<ResourceTableView>;
    formData: ResourceFormData | null;
  }
};

export type ResourceForm = {
  title: string;
  description: string;
  descriptionText: string;
  publishSettingsPrograms: string;
  programs: SelectItem[];
  postType: string;
  publiclyAvailable: boolean;
  commentsAllowed: boolean;
  isPublicOnPcs: boolean;
  pinnedToTop?: boolean;
  fromDate?: Date | null;
  toDate?: Date | null;
  fromTime?: string;
  toTime?: string;
  withEndDate?: boolean;
  timezone?: string;
  eventFormat?: string;
  eventPersonAddress?: string;
  location?: google.maps.LatLngLiteral;
  eventLink?: string;
  networks?: SelectItem[];
  offeredBy?: string;
  organizationName?: string;
  organizationWebsite?: string;
  groupName?: string;
  displayName?: string;
  contactInfo?: string;
  specialties?: string[];
  serviceDeliveryMethods?: string[];
  serviceArea?: string;
  compensation?: string;
  ratePricing?: string;
  availability?: string;
  productLocationType?: string;
  productLocation?: string;
  productUrl?: string;
  costType?: string;
  priceDetails?: string;
  removeCoverImage?: boolean;
};

export type ResourceTableView = ResourceBaseTableView & {
  programsNames: string;
  shareStatus?: ResourceSharedStatuses;
  shareUpdatedAt?: Date;
};

export type GetResourcesTableFilters = {
  text?: string;
};

export type GetResourcesTable = {
  filters: GetResourcesTableFilters;
  paging: Paging;
};

export type ResourceFormData = {
  postTypesSelectList: SelectItem[];
  postTypesContextSelectList: SelectItem[];
  timezoneSelectList: SelectItem[];
  eventFormatSelectList: SelectItem[];
  offeredBySelectList?: SelectItem[];
  serviceDeliveryMethodSelectList?: SelectItem[];
  compensationSelectList?: SelectItem[];
  productLocationTypeSelectList?: SelectItem[];
  costTypeSelectList?: SelectItem[];
  title?: string;
  description?: string;
  descriptionText?: string;
  programs?: SelectItem[];
  file?: string;
  coverImage?: string;
  postType?: string;
  publiclyAvailable?: boolean;
  commentsAllowed?: boolean;
  isPublicOnPcs?: boolean;
  pinnedToTop?: boolean;
  fromDate?: string;
  toDate?: string;
  fromTime?: string;
  toTime?: string;
  withEndDate?: boolean;
  timezone?: string;
  eventFormat?: string;
  eventPersonAddress?: string;
  location?: google.maps.LatLngLiteral | undefined;
  eventLink?: string;
  status?: string;
  networks?: SelectItem[];
  postedByAdminCommunityId?: string;
  offeredBy?: string;
  organizationName?: string;
  organizationWebsite?: string;
  groupName?: string;
  displayName?: string;
  contactInfo?: string;
  specialties?: string[];
  serviceDeliveryMethods?: string[];
  serviceArea?: string;
  compensation?: string;
  ratePricing?: string;
  availability?: string;
  productLocationType?: string;
  productLocation?: string;
  productUrl?: string;
  costType?: string;
  priceDetails?: string;
}

export type ResourceFormFieldsValidation<T> = {
  isValid: boolean;
  hasOnlyProgramsError: boolean;
  validationErrors: FormikErrors<T>;
  errorsCount: number;
}

export type JobFormRef<T> = FormikProps<T> & {
  validateJobFormFields: (forDraft: boolean, validateForm: Function, values: T, setFieldError: (field: string, message: string | undefined) => void, setFieldTouched: (field: string, isTouched?: boolean, shouldValidate?: boolean) => void) => Promise<ResourceFormFieldsValidation<T>>;
  validateSelectedPrograms: (programs: SelectItem[], jobTypes: string[]) => Promise<any>;
};

export enum GetResourceFormDataTypes {
  Organozation = 'Organozation',
  JobSeeker = 'JobSeeker',
}

export enum ResourceEventFormatTypes {
  InPerson = 'InPerson',
  Virtual = 'Virtual',
}

export enum ResourceEventRsvpStatuses {
  Going = 'Going',
  Maybe = 'Maybe',
  NotGoing = 'NotGoing',
}

export enum ResourceTypes {
  Update = 'Update',
  Resource = 'Resource',
  Event = 'Event',
  Products = 'Products',
  Services = 'Services',
}

export enum OfferedByType {
  Me = 'Me',
  MyOrganization = 'MyOrganization',
  Group = 'Group',
  Other = 'Other',
}

export enum ServiceDeliveryMethod {
  OnSite = 'OnSite',
  Remote = 'Remote',
}

export enum CompensationType {
  Paid = 'Paid',
  Free = 'Free',
}

export enum ProductLocationType {
  AtLocation = 'AtLocation',
  Online = 'Online',
}

export enum CostType {
  Paid = 'Paid',
  Free = 'Free',
}
